import { render, staticRenderFns } from "./CreateCompensation.vue?vue&type=template&id=2d4a3a2b"
import script from "./CreateCompensation.vue?vue&type=script&lang=js"
export * from "./CreateCompensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports